import { FC, useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';

import { ErrorCurtain } from '../components/ErrorCurtain';
import { useRecordError } from '../hooks/useRecordError';
import { isDynamicImportError } from '../utils/error';

export interface ErrorScreenProps {
  error?: unknown;
}

export const ErrorScreen: FC<ErrorScreenProps> = ({ error: providedError }) => {
  const routeError = useRouteError();
  const error = providedError ?? routeError;
  const recordError = useRecordError();

  useEffect(() => {
    if (isRouteErrorResponse(error) && error.status == 404) return;
    if (isDynamicImportError(error)) return;
    recordError(error);
  }, [error, recordError]);

  return <ErrorCurtain error={error} />;
};
